var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_7",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0032 26.3889C22.0103 26.3889 23.7152 25.6864 25.118 24.2815C26.5208 22.8765 27.2222 21.1705 27.2222 19.1634C27.2222 17.1563 26.5197 15.4514 25.1148 14.0486C23.7098 12.6459 22.0038 11.9445 19.9967 11.9445C17.9896 11.9445 16.2847 12.6469 14.8819 14.0519C13.4791 15.4569 12.7778 17.1629 12.7778 19.1699C12.7778 21.177 13.4802 22.8819 14.8852 24.2847C16.2901 25.6875 17.9962 26.3889 20.0032 26.3889ZM19.9934 23.7778C18.7108 23.7778 17.6227 23.3289 16.7291 22.431C15.8356 21.5331 15.3888 20.4428 15.3888 19.1601C15.3888 17.8775 15.8378 16.7894 16.7357 15.8958C17.6335 15.0023 18.7238 14.5555 20.0065 14.5555C21.2892 14.5555 22.3773 15.0045 23.2708 15.9024C24.1643 16.8002 24.6111 17.8905 24.6111 19.1732C24.6111 20.4559 24.1621 21.544 23.2643 22.4375C22.3664 23.331 21.2761 23.7778 19.9934 23.7778ZM20 31.6667C15.9444 31.6667 12.2685 30.5208 8.97217 28.2292C5.67589 25.9375 3.24071 22.9167 1.66663 19.1667C3.24071 15.4167 5.67589 12.3958 8.97217 10.1042C12.2685 7.81251 15.9444 6.66667 20 6.66667C24.0555 6.66667 27.7314 7.81251 31.0278 10.1042C34.324 12.3958 36.7592 15.4167 38.3333 19.1667C36.7592 22.9167 34.324 25.9375 31.0278 28.2292C27.7314 30.5208 24.0555 31.6667 20 31.6667ZM19.9953 28.8889C23.2854 28.8889 26.3078 28.007 29.0625 26.2431C31.8171 24.4792 33.9166 22.1204 35.3611 19.1667C33.9166 16.213 31.8187 13.8542 29.0672 12.0903C26.3156 10.3264 23.2948 9.44442 20.0046 9.44442C16.7145 9.44442 13.6921 10.3264 10.9375 12.0903C8.18282 13.8542 6.07401 16.213 4.61104 19.1667C6.07401 22.1204 8.18125 24.4792 10.9328 26.2431C13.6843 28.007 16.7051 28.8889 19.9953 28.8889Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.36c1fbd1b6e16ed795b1f655c0200414.svg";
export { ForwardRef as ReactComponent };